import React from 'react';
import { useTranslation } from 'react-i18next';

import { ScaleVisualization } from '~src/interfaces/scale.interface';
import ListItem from '~src/shared/lists/listItem/ListItem';
import { HoverContent, ListItemProps } from '~src/shared/lists/listItem/types';

interface Props {
  scaleName: string;
  visualization: ScaleVisualization;
  labels: Array<{ [key: string]: string }>;
  link: string;
}

const ScaleItem: React.FC<Props> = React.memo(function RenderScaleItem({ visualization, link, scaleName, labels }) {
  const { t } = useTranslation();

  const itemProps: ListItemProps<string> = [
    {
      key: `x.scale.type.${visualization}`,
      txt: t(`x.scale.type.${visualization}`),
    },
  ];

  const hoverContent: HoverContent = {
    wideBtn: {
      key: 'x.scales.list.item.edit_label',
      txt: t('x.scales.list.item.edit_label'),
      icon: 'iconGear',
      link,
    },
  };
  let labelsKey;
  let labelsLength;
  let labelsTConf;

  if (visualization === ScaleVisualization.Labels) {
    labelsLength = labels.length;
    labelsKey = 'x.scales.list.item.labels';
    labelsTConf = { count: labelsLength };
  } else if (labels[0]) {
    labelsKey = 'x.scales.list.item.with_popover';
  }

  if (labelsKey) {
    itemProps.push({
      key: labelsKey,
      txt: `${labelsLength || ''} ${t(labelsKey, labelsTConf)}`,
    });
  }

  return <ListItem title={scaleName} itemProps={itemProps} hoverContent={hoverContent} />;
});

export default ScaleItem;
